import type { DcEntity } from '@/libs/api'

export const mapToDcFieldName = (dc: DcEntity) => {
  return `${dc.code}/${dc.name}`
}
